export enum DesignElementType {
  Unknown = 0,
  BusinessProcess = 1,
  State = 2,
  Field = 3,
  Flow = 4,
  Layout = 5,
  View = 6
}


